import Kiosk from "./Kiosk"
import Infographic from "./Infographic"
import Button from "./Shared/Button"

export { WaitingToRideScene } from "./CommitView"
export { reducer } from "./redux"
export { Infographic, Button }

export default Kiosk



// WEBPACK FOOTER //
// ./src/Kiosk/index.js